import React , { useEffect } from "react";
import { FooterFieldsFragment, Logo } from "@src/generated/graphql";
import { Link } from "react-router-dom";
import DynamicLink from "../shared/DynamicLink";
import { SectionWrapper, Typography } from "../shared";
import Vector from "../../../src/images/Vector.png";
import GradielLogo from "../../../src/images/Gradial_Logo.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { highlightUnderscoreText } from "src/utils/utils";
import { useAppContext } from "../contextAPI/AppContext";

type FooterProps = {
  content?: FooterFieldsFragment;
  logoUrl: string;
  contactData?: {
    title?: string;
    buttonData?: {
      buttonLink: string;
      buttonText: string;
    };
    bgImage?: {
      title: string;
      url: string;
    };
  };
};

declare global {
  interface Window {
    hbspt?: any;
  }
}

const Footer = ({ content, logoUrl, contactData }: FooterProps) => {
  const currentLogo = logoUrl;
  const linksCollection = content?.footerLinksCollection?.items;
  const socialMediaLinks = content?.socialMediaLinksCollection?.items;
  const copyrightText = content?.copyrightText;
  const { data, updateTitle, updateButtonLink } = useAppContext();
console.log("Data from footer",data);

  useEffect(() => {
    if (!document.getElementById('hs-forms-script')) {
      const script = document.createElement('script');
      script.id = 'hs-forms-script';
      script.src = '//js.hsforms.net/forms/embed/v2.js';
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.onload = () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: '45649448',
            formId: 'fef787ff-4649-488c-9573-d8551e94b114',
            region: 'na1',
            target: '#newsletter-form',
          });
        }
      };
      document.body.appendChild(script);
    } else if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: '45649448',
        formId: 'fef787ff-4649-488c-9573-d8551e94b114',
        region: 'na1',
        target: '#newsletter-form',
      });
    }
  }, []);

  return (
    <>
      <footer
        className="footer"
        style={{
          position: "relative",
          zIndex: 10,
          background: "#131327",
          color: "#fff",
        }}
      >
        <img
          src={Vector}
          alt="footer-image"
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: "100%",
            maxHeight: "100%",
            zIndex: -1,
            opacity: 0.2,
          }}
        />

        <div className="footer-component pt-32">
          <div className="container-fluid custom-spacer-col">
            <div className="row footer_newsletter">
              <div className="col-md-6 col-lg-6">
                <div className="newsletter_details">
                  <h2>Subscribe to our newsletter</h2>
                  <p>Get The Latest News & Updates</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div id="newsletter-form">
                </div>
              </div>
            </div>
            <div className="row">
              {
                <div className="col-md-4 col-lg-4">
                  <div className="footer-logo">
                    <Link className="navbar-brand" to="/">
                      <img
                        className="logo"
                        src={currentLogo ?? ""}
                        alt={content?.logo?.logoName ?? ''}
                      />
                    </Link>
                  </div>
                </div>
              }
              
              <div className="col-md-8 col-lg-8">
                <div className="footer-links-wrap">
                  {linksCollection?.map((linkCategory, index) => (
                    <div className="footer-links-list" key={index}>
                      <h6>{linkCategory?.heading}</h6>
                      <ul className="nav">
                        {linkCategory?.linksCollection?.items.map(
                          (link, idx) => (
                            <li className="nav-item" key={idx}>
                              <DynamicLink
                                style={{ color: "#fff" }}
                                url={link?.linkUrl}
                              >
                                {link?.linkText}
                              </DynamicLink>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="footer-secondary" style={{ position: "relative" }}>
              <hr
                style={{
                  marginTop: "20px",
                  position: "absolute",
                  border: "2px solid #f5f5f5",
                  backgroundColor: "#f5f5f5",
                  width: "100%",
                  top: "0",
                }}
              />

              <div className="social-media">
                {socialMediaLinks?.map((socialLink, index) => (
                  <DynamicLink
                    key={index}
                    url={socialLink?.linkUrl ?? ""}
                    className="icon-link"
                  >
                    <img
                      src={socialLink?.linkIcon?.url ?? ""}
                      alt={socialLink?.linkIcon?.title ?? ""}
                    />
                  </DynamicLink>
                ))}
              </div>
              <div className="footer-copyright">
                <p style={{ color: "#fff" }}>{copyrightText}</p>
              </div>
            </div>
          </div>
        </div>
        {contactData && (
          <div className="contact-wrapper">
            <div>
              <div className="gradient-bg-wrapper">
                <div
                  className="gradient-content-wrapper text-center"
                  style={{ padding: "20px" }}
                >
                  <h2
                    className="heading light"
                    dangerouslySetInnerHTML={{
                      __html: highlightUnderscoreText(data?.title ?? contactData.title ?? ""),
                    }}
                  />
                  <DynamicLink
                    url={contactData.buttonData?.buttonLink}
                    className="btn-default-bdr"
                  >
                    <span>{data?.buttonLink?.buttonText ?? contactData.buttonData?.buttonText}</span>
                    <FaArrowRightLong className="btn-icon" />
                  </DynamicLink>
                </div>
              </div>
            </div>
          </div>
        )}
      </footer>
    </>
  );
};

export default Footer;
